import type { IStockRepository } from '@/features/stock/domain/repositories/IStockRepository.js';

interface Deps { stockRepository: IStockRepository; }

export function createDeleteAssetUseCase({ stockRepository }: Deps) {
  return async function deleteAsset(id: string): Promise<void> {
    return stockRepository.deleteAsset(id);
  };
}
